import {Action, ActionsListData} from '../Actions';
import {StateListData, StateListDataItem} from '../State';

type PartialStateListData = Pick<StateListData, keyof StateListData>;

function setItems(
	items: StateListDataItem[] = [],
	itemsLeft: number = 0,
	nextItemsOffset: number = 0,
): Action<typeof ActionsListData>
{
	return {
		type: ActionsListData.LIST_DATA$_SET_ITEMS,
		payload: {
			items,
			itemsLeft,
			nextItemsOffset,
		} as PartialStateListData,
	};
}

function appendItems(
	items: StateListDataItem[] = [],
	itemsLeft: number = 0,
	nextItemsOffset: number = 0,
): Action<typeof ActionsListData>
{
	return {
		type: ActionsListData.LIST_DATA$_APPEND_ITEMS,
		payload: {
			items,
			itemsLeft,
			nextItemsOffset,
		} as PartialStateListData,
	};
}

function setListMode(
	listMode: boolean,
): Action<typeof ActionsListData>
{
	return {
		type: ActionsListData.LIST_DATA$_SET_LIST_MODE,
		payload: {
			listMode,
		} as PartialStateListData,
	};
}

/**
 * Module.
 */
export {
	setItems,
	appendItems,
	setListMode,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/App/Store/creators/listData.ts